import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-LeftArrowShape",
  "use": "svg-icon-LeftArrowShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-LeftArrowShape\"><path d=\"M5.032 2.932a.75.75 0 1 0-1.06-1.06L.55 5.291a1 1 0 0 0 0 1.415l3.42 3.424a.75.75 0 1 0 1.061-1.061l-.86-.86a10 10 0 0 0-1.758-1.4l-.32-.201.034-.035.543.078c.469.066.941.1 1.415.1h7.164a.75.75 0 0 0 0-1.5H4.086a10 10 0 0 0-1.415.1l-.543.078-.035-.035.324-.203a10 10 0 0 0 1.755-1.398l.86-.86z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol